import React, { FunctionComponent } from 'react';
import { classNames } from '../lib/classNames';

interface Step {
  Title: FunctionComponent;
  Description?: FunctionComponent;
  isComplete?: boolean;
}

const VerticalProgressBar: FunctionComponent<{
  steps: Step[];
}> = ({ steps }) => {
  return (
    <div className="mx-auto max-w-xl">
      <div className="grid gap-6 row-gap-10">
        <div>
          {steps.map((step, index) => {
            const isLastStep = steps.length - 1 === index;
            return (
              <div className="flex" key={index}>
                <div className="flex flex-col items-center mr-4 pt-1">
                  <div>
                    <div
                      className={classNames(
                        'w-3 h-3 mx-auto rounded-full',
                        step.isComplete
                          ? 'bg-theme-primary'
                          : ' border-2 border-theme-primary'
                      )}
                    />
                  </div>
                  {!isLastStep && (
                    <div className="w-1 h-full bg-theme-primary bg-opacity-50 rounded mt-1" />
                  )}
                </div>
                <div className="pt-0 pb-2 w-full">
                  <div className="mb-1 text-sm font-extrabold">
                    <step.Title />
                  </div>
                  <div className="mb-1">
                    {step.Description && <step.Description />}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VerticalProgressBar;
